import type {
  ContractsRequest,
  ContractsResponse,
  ParticipantDetailResponseDTO,
  ParticipantSearchRequest,
  ParticipantSearchResponse,
  ParticipantUpdateRequestDTO,
} from '../../types/previdencia/previdenciaType';
import { PREVIDENCIA_PARTICIPANTS_ROUTES } from '../requestsService';

export class ParticipantService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Search participants
   * Matches backend endpoint: /v1/bff/previdencia/participants/search
   * @param params - Search parameters
   */
  async searchParticipants(params: ParticipantSearchRequest): Promise<ParticipantSearchResponse> {
    const queryParams = new URLSearchParams();

    queryParams.append('companyId', params.companyId);

    if (params.contractNumber) {
      queryParams.append('contractNumber', params.contractNumber);
    }
    if (params.participantName) {
      queryParams.append('participantName', params.participantName);
    }
    if (params.registrationNumber) {
      queryParams.append('registrationNumber', params.registrationNumber);
    }
    if (params.cpf) {
      queryParams.append('cpf', params.cpf);
    }
    if (params.orderDir) {
      queryParams.append('orderDir', params.orderDir);
    }
    if (params.page !== undefined) {
      queryParams.append('page', params.page.toString());
    }
    if (params.size !== undefined) {
      queryParams.append('size', params.size.toString());
    }

    const url = `${PREVIDENCIA_PARTICIPANTS_ROUTES.GET_SEARCH_PARTICIPANTS}?${queryParams.toString()}`;

    return this.fetch<ParticipantSearchResponse>(url, {
      method: 'GET',
    });
  }

  /**
   * Get participant detail
   * Matches backend endpoint: /v1/bff/previdencia/participants/detail
   * @param participantEnrollmentId - Participant enrollment ID
   */
  async getParticipantDetail(
    participantEnrollmentId: number
  ): Promise<ParticipantDetailResponseDTO> {
    const url = `${PREVIDENCIA_PARTICIPANTS_ROUTES.GET_PARTICIPANT_DETAIL}?participantEnrollmentId=${encodeURIComponent(participantEnrollmentId)}`;

    return this.fetch<ParticipantDetailResponseDTO>(url, {
      method: 'GET',
    });
  }

  /**
   * Update participant
   * Matches backend endpoint: /v1/bff/previdencia/update-participant
   * @param request - Participant update data
   */
  async updateParticipant(
    request: ParticipantUpdateRequestDTO
  ): Promise<ParticipantDetailResponseDTO> {
    return this.fetch<ParticipantDetailResponseDTO>(PREVIDENCIA_PARTICIPANTS_ROUTES.PUT_UPDATE_PARTICIPANT, {
      method: 'PUT',
      body: JSON.stringify(request),
    });
  }

  /**
   * Get contracts
   * Matches backend endpoint: /v1/bff/previdencia/contracts
   * @param params - Request parameters
   */
  async getContracts(params: ContractsRequest): Promise<ContractsResponse> {
    const queryParams = new URLSearchParams();

    queryParams.append('companyId', params.companyId);

    if (params.orderDir) {
      queryParams.append('orderDir', params.orderDir);
    }
    if (params.page !== undefined) {
      queryParams.append('page', params.page.toString());
    }
    if (params.size !== undefined) {
      queryParams.append('size', params.size.toString());
    }

    const url = `${PREVIDENCIA_PARTICIPANTS_ROUTES.GET_CONTRACTS}?${queryParams.toString()}`;

    return this.fetch<ContractsResponse>(url, {
      method: 'GET',
    });
  }


}

